var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#B1FF1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 24.5L20.6482 14.76L17.6329 11.58L32 9L29.6646 23.19L26.4424 20.61L17.6329 29.5",
    stroke: "#B1FF1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 21L8 30",
    stroke: "#B1FF1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22L13 30",
    stroke: "#B1FF1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorIcon1);
export default __webpack_public_path__ + "static/media/investor-icon-1.c65dd692bb4021501746f64db8772fa5.svg";
export { ForwardRef as ReactComponent };